import { useOutstandingFilterContext } from '../../context/useOutstandingFilterContext'

export const useToggleOutstandingFilter = () => {
  const { toggleIsOutstandingFilter } = useOutstandingFilterContext()

  return {
    toggleFilter: toggleIsOutstandingFilter,
  }
}
